import type { Theme } from '@mui/material';

import { brandBackground } from 'src/theme/brandBackground';

export const styles = {
  halfPageWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 0,
    width: '50%',
  },

  toolLogoBox: {
    justifyContent: 'center',
  },

  toolLogoWrapper: {
    width: '100%',

    '> img': {
      maxHeight: '6.5rem',
      maxWidth: '100%',
      objectFit: 'contain',
    },
  },

  toolName: (theme: Theme) => ({
    pt: 1,
    color: theme.colors.neutral[600],
    fontWeight: 500,
  }),

  formBackground: {
    position: 'relative',
    pt: 8,
    pb: 7,
  },

  formBox: {
    justifyContent: 'center',
    flexGrow: 1,
    overflow: 'hidden',
  },

  formWrapper: {
    maxWidth: '34rem',
    justifyContent: 'center',
  },

  formOverflowHandler: {
    overflowY: 'auto',
    px: 4,
  },

  logoBackground: (theme: Theme) => ({
    background: brandBackground(theme),
  }),

  imageBox: {
    justifyContent: 'center',
    px: '18%',
    height: '100%',
  },

  imageWrapper: {
    width: '100%',
    height: '66%',

    '> img': {
      maxHeight: '100%',
      objectFit: 'contain',
    },
  },
};
